import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy URL — platform settings are a section of the unified Settings page. */
export const Route = createFileRoute("/_layout/admin-settings/")({
	beforeLoad: () => {
		throw redirect({
			to: "/settings",
			search: { view: "model", section: "partner" },
			replace: true,
		});
	},
});
